import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {FaIcon} from '../FaIcon';
import {ReportHeader} from '../public_reports/ReportHeader';
import {ReportSummary} from '../public_reports/ReportSummary';
import {ReportBlocks} from '../public_reports/ReportBlocks';
import {ReportFooter} from '../public_reports/ReportFooter';
import {DEMO_REPORT} from './utils/demoReportData';
import '../public_reports/ReportViewer.scss';

export function DemoReportPage() {
    const {t} = useTranslation();

    return (
        <div className="report-viewer">
            <div className="report-nav">
                <Link to="/dashbo-mcp" className="report-nav-back">
                    <FaIcon iconName="arrow-left"/> {t('dashbo_mcp.demo_report.back')}
                </Link>
            </div>

            <div className="report-container">
                <ReportHeader
                    title={DEMO_REPORT.title}
                    generatedAt={DEMO_REPORT.generated_at}
                    branding={DEMO_REPORT.branding}
                />
                <ReportSummary summary={DEMO_REPORT.summary}/>
                <ReportBlocks
                    blocks={DEMO_REPORT.blocks}
                    reportId="demo"
                    isAuthenticated={false}
                />
                <ReportFooter branding={DEMO_REPORT.branding}/>
            </div>

            <div className="demo-report-banner">
                <div className="demo-banner-content">
                    <span className="demo-banner-icon"><FaIcon iconName="robot"/></span>
                    <span className="demo-banner-text">{t('dashbo_mcp.demo_report.banner_title')}</span>
                    <Link to="/dashbo-mcp" className="btn -alt demo-banner-cta">
                        {t('dashbo_mcp.demo_report.banner_cta')}
                    </Link>
                </div>
            </div>
        </div>
    );
}
